class StickyAbsoluteWrap extends HTMLElement {
  constructor() {
    super();
    this.stickyEl = this.querySelector(".saw-sticky");
    this.stickyAbsoluteChild = this.querySelector(".saw-sticky-absolute");
    this.relativeContainer = this.querySelector(".saw-relative-container");
    const verifyElementsArray = [
      {
        element: this.stickyEl,
        name: "Sticky element"
      },
      {
        element: this.stickyAbsoluteChild,
        name: "Sticky absolute child element"
      },
      {
        element: this.relativeContainer,
        name: "Relative container element"
      }
    ];
    if (this.verifyElements(verifyElementsArray)) {
      return;
    }
    this.initResizeObserver();
  }
  verifyElements(array) {
    let error = false;
    array.forEach((item) => {
      if (item.element === null) {
        console.error(`${item.name} not found in StickyAbsoluteWrap`);
        error = true;
      }
    });
    console.log("StickyAbsoluteWrap", array);
    return error;
  }
  /**
   * Initializes a resize observer for the relative container
   * Updates the max height of the absolute child element when container size changes
   */
  initResizeObserver() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === this.relativeContainer) {
          this.updateAbsoluteChildMaxHeight();
        }
      }
    });
    this.resizeObserver.observe(this.relativeContainer);
    this.updateAbsoluteChildMaxHeight();
  }
  /**
   * Updates the maximum height of the absolute child element
   * to match the height of the relative container
   */
  updateAbsoluteChildMaxHeight() {
    const containerHeight = this.relativeContainer.offsetHeight;
    this.stickyAbsoluteChild.style.maxHeight = `calc(${containerHeight}px + (var(--notificationOffset, 0px) * 2))`;
    this.stickyAbsoluteChild.style.bottom = "calc(var(--notificationOffset, 0px) )";
    this.stickyAbsoluteChild.style.height = "100vh";
  }
  /**
   * Clean up the resize observer when element is disconnected from DOM
   */
  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
if (!customElements.get("sticky-absolute-wrap")) {
  customElements.define("sticky-absolute-wrap", StickyAbsoluteWrap);
}
export {
  StickyAbsoluteWrap
};
